import * as Sentry from '@sentry/react';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';
import App from './App';
import './assets/css/index.css';

// Initialize GlitchTip/Sentry for error monitoring
const sentryDsn = (window as unknown as { __ENV__?: { SENTRY_DSN?: string } }).__ENV__?.SENTRY_DSN;
Sentry.init({
  dsn: sentryDsn,
  environment: import.meta.env.MODE,
  enabled: !!sentryDsn,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: import.meta.env.MODE === 'development' ? 1.0 : 0.1,
  sendDefaultPii: false,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
